import type { RangeKey } from '@/api/types';
import { local } from '@/lib/storage';

export const RANGE_KEY = 'mydash.range';
export const RANGES: { value: RangeKey; label: string }[] = [
  { value: 'today', label: 'Today' },
  { value: '7d', label: '7 days' },
  { value: '30d', label: '30 days' },
];
export const COMPARED_TO: Record<RangeKey, string> = {
  today: 'yesterday',
  '7d': 'previous 7 days',
  '30d': 'previous 30 days',
};

export function readRange(): RangeKey {
  const v = local.get<string>(RANGE_KEY, '7d');
  return v === 'today' || v === '7d' || v === '30d' ? v : '7d';
}
